import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/config';

/**
 * Check if the current user has admin access
 * @param {string} userId - The user's UID
 * @returns {Promise<boolean>} - True if user is admin
 */
export const checkAdminAccess = async (userId) => {
  try {
    const userDoc = await getDoc(doc(db, 'users', userId));
    if (!userDoc.exists()) {
      console.error('User document not found');
      return false;
    }

    const userData = userDoc.data();
    const isAdmin = userData.role === 'admin' || 
                    userData.role === 'superadmin' || 
                    userData.role === 'founder' || 
                    userData.isAdmin === true;

    console.log('User data:', {
      role: userData.role,
      isAdmin: userData.isAdmin,
      hasAdminAccess: isAdmin
    });

    return isAdmin;
  } catch (error) {
    console.error('Error checking admin access:', error);
    return false;
  }
};

export default checkAdminAccess;
